export default __webpack_public_path__ + "static/media/serbgo-screenshot-06.a14fc1d7.png";